import VProgressLinear from './VProgressLinear'
import VProgressCircular from './VProgressCircular'

export default {
  VProgressLinear,
  VProgressCircular
}



// WEBPACK FOOTER //
// ./src/components/progress/index.js